import NavBar from 'react-bootstrap/NavBar';
import './Navbar.css';
import AuthedNavbarContent from './AuthedNavbarContent';
import GuestNavbarContent from './GuestNavbarContent';
import { useAuthContext } from '../hooks/useAuth';

const Navbar = ({ logout, search }) => {
  const { token } = useAuthContext();
  return (
    <NavBar expand="lg" className="hdr-bg">
      {token ? (
        <AuthedNavbarContent logout={logout} search={search} />
      ) : (
        <GuestNavbarContent />
      )}
    </NavBar>
  );
};

export default Navbar;
